export const all_routes = {
  home: '/',

  // Auth Routes
  register: '/auth/register',
  login: '/auth/login',
  changePassword: '/auth/change-password',
  forgotPassword: '/auth/forgot-password',

  // Pages Routes
  contactUs: '/contact-us',
  aboutUs: '/about-us',
  comingSoon: '/coming-soon',
  serviceDetail: '/services/details',
  laneRental: '/lane-rental',
  bookACoach: '/book-a-coach',
  hpcActive: '/hpc-active',
  services: '/services',
  termsCondition: '/terms-condition',
  testimonials: '/testimonials',
  maintenance: '/maintenance',
  cookiePolicy: '/cookie-policy',
  gallery: '/gallery',
  error404: '/error-404',

  // Booking flow
  bookingType: '/booking-type',
  bookingAvailability: '/booking-type/:bookingType/location/:locationId/time&date',
  bookingPersonalInformation:
    '/booking-type/:bookingType/location/:locationId/personal-information',
  bookingPayment: '/booking-type/:bookingType/location/:locationId/payment',
  bookingSummary: '/booking/summary/:refCode',
  bookingLocation: '/booking-type/:bookingType/location',
  bookingAddOns: '/booking-type/:bookingType/location/:locationId/add-ons',

  // User Routes
  userBookings: '/user/bookings/:status',
  userBookingsPrefix: '/user/bookings',
  userWallet: '/user/user-wallet',
  userProfile: '/user/settings/profile',
  userSettingPassword: '/user/settings/password',

  // not been used
  pricing: '/pricing',
  ourTeams: '/our-teams',
  myProfile: '/user/my-profile',
  faq: '/faq',
  coachDashboard: 'coaches/coach-dashboard',
  allCourt: '/coaches/all-court',
  coachRequest: '/coaches/coach-request',
  coachBooking: '/coaches/coach-booking',
  coachChat: '/coaches/coach-chat',
  coachEarning: '/coaches/coach-earning',
  coachWallet: '/coaches/coach-wallet',
  coachProfile: '/coaches/coach-profile',
  activeCourt: '/coaches/active-court',
  inactiveCourt: '/coaches/inactive-court',
  cageCheckout: '/coaches/cage-checkout',
  cageDetails: '/coaches/cage-details',
  cageOrderConfirm: '/coaches/cage-order-confirm',
  cagePersonalInfo: '/coaches/cage-personal-info',
  lessonOrderConfirm: '/coaches/lesson-order-confirm',
  lessonPayment: 'coaches/lesson-payment',
  lessonPersonalInfo: 'coaches/lesson-personal-info',
  lessonTimeDate: '/coaches/lesson-time-date',
  lessonType: '/coaches/lesson-type',
  availabilitySettings: '/coaches/availability-settings',
  settingPassword: '/coaches/setting-password',
  profileOtherSettings: '/coaches/profile-other-settings',
  settingLesson: '/coaches/setting-lesson',
  events: '/pages/events',
  eventDetails: '/pages/event-details',
  userCancelled: '/user/bookings/cancelled',
  userOngoing: '/user/bookings/ongoing',
  userComplete: '/user/bookings/completed',
  userChat: '/user/user-chat',
  // Blog Routes
  blogGridSidebarRight: '/article',
  blogDetailsSidebarRight: '/article/:slug',
  blogDetails: '/blog/blog-details',
  // Coaches Routes
  bookingCancelled: '/coaches/booking-cancelled',
  bookingCompleted: '/coaches/booking-completed',
  coachPersonalInfo: '/coaches/coach-personal-info',
  coachOrderConfirm: '/coaches/coach-order-confirm',
  coachPayment: '/coaches/coach-payment',
  invoice: '/coaches/invoice',
  // User routes
  userDashboardProfiles: '/user/user-dashboard-profiles',
  userDashboard: '/user/dashboard',
  userInvoice: '/user/user-invoice',
  userCoaches: '/user/user-coaches',
  userProfileOtherSetting: '/user/settings/other',
  //Listing Routes
  locations: '/location',
  location: '/location/:locationId',
  lanes: '/location/:locationId/lanes',
  coachesGrid: '/location/:locationId/coaches',
  coachDetail: '/location/:locationId/coaches/:id/:name',
}
